import { createElementBlock as e, openBlock as r, renderSlot as o } from "vue";
import { _ as s } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const a = {}, c = {
  "aria-hidden": "true",
  class: "stash-backdrop tw-fixed tw-inset-0 tw-z-behind tw-bg-black/50",
  "data-test": "stash-backdrop"
};
function d(t, n) {
  return r(), e("div", c, [
    o(t.$slots, "default")
  ]);
}
const f = /* @__PURE__ */ s(a, [["render", d]]);
export {
  f as default
};
//# sourceMappingURL=Backdrop.js.map
